var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lottie-micro-ani-handler no-flicker",style:({
    top: _vm.microAnimation.animationPosition.top + '%',
    left: _vm.microAnimation.animationPosition.left + '%',
    width: _vm.microAnimation.width + '%',
    height: _vm.microAnimation.height + '%'
  }),attrs:{"id":_vm.sectionIdName}},[_c('lottie',{ref:"lottie",staticClass:"lottie-micro-ani-handler__lottie-wrapper",on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }